<template>
    <div>Oops! Something went wrong!</div>
</template>

<script>
    export default {
        name: "NotFound"
    }
</script>

<style scoped>

</style>
